module.exports = __webpack_public_path__ + "img/event-banner01.e9d339fd.png";